export default __webpack_public_path__ + "static/media/le_croise11.ab924921.jpg";